const BROWSER_MANAGED_HEADERS = new Set(['host', 'content-length']);
const SERVER_SIDE_ENCRYPTION_HEADER = 'x-amz-server-side-encryption';

// Presigned PUT URLs sign SSE without always embedding the value in query params.
const DEFAULT_SERVER_SIDE_ENCRYPTION = 'AES256';

const normalizeHeaders = headers =>
  Object.entries(headers ?? {}).reduce((normalizedHeaders, [name, value]) => {
    const headerName = name.toLowerCase();

    if (value != null && !BROWSER_MANAGED_HEADERS.has(headerName)) {
      normalizedHeaders[headerName] = String(value);
    }

    return normalizedHeaders;
  }, {});

const getSignedHeaders = parsedUrl =>
  (parsedUrl.searchParams.get('X-Amz-SignedHeaders') ?? '')
    .split(';')
    .map(headerName => headerName.trim().toLowerCase())
    .filter(Boolean);

export const getExplicitUploadHeaders = source =>
  normalizeHeaders(
    source?.headers ?? source?.uploadHeaders ?? source?.upload_headers
  );

export const getInferredUploadHeadersFromUrl = uploadTo => {
  const parsedUrl = new URL(uploadTo);

  if (!getSignedHeaders(parsedUrl).includes(SERVER_SIDE_ENCRYPTION_HEADER)) {
    return {};
  }

  return {
    [SERVER_SIDE_ENCRYPTION_HEADER]:
      parsedUrl.searchParams.get(SERVER_SIDE_ENCRYPTION_HEADER) ??
      DEFAULT_SERVER_SIDE_ENCRYPTION
  };
};

export const getUploadRequestHeaders = config => {
  const explicitHeaders = getExplicitUploadHeaders(config);

  return {
    ...getInferredUploadHeadersFromUrl(config.uploadTo),
    ...explicitHeaders
  };
};
